import { helpHttp } from "../helpers/helpHttp";
import swal from "sweetalert";
const { createContext, useState, useEffect } = require("react");

const CrudContext = createContext();

const CrudProvider = ({ children }) => {
  const [db, setDb] = useState([]);
  const [dataToEdit, setDataToEdit] = useState(null);
  const [loader, setLoader] = useState(true);
  const [auth, setAuth] = useState(false);

  let api = helpHttp();
  let url = "https://estasi1.herokuapp.com/productos/";

  useEffect(() => {
    api.get(url).then((res) => {
      if (!res.ok) {
        setLoader(false);
        setDb(res);
      } else {
        setDb(null);
      }
    });
  });

  const createData = (data) => {
    let options = {
      body: data,
      headers: { "Content-type": "application/json" },
    };

    api.post(url, options).then((res) => {
      if (!res.ok) {
        setDb(res);
      } else {
        setDb(null);
      }
    });
  };

  const updateData = (data) => {
    let options = {
      body: data,
      headers: { "Content-type": "application/json" },
    };

    let endpoint = `${url}${data.pro_id}`;

    api.put(endpoint, options).then((res) => {
      if (!res.ok) {
        let newData = Object.values(db).map((el) =>
          el.pro_id === data.pro_id ? data : el
        );
        setDb(newData);
        setDataToEdit(null);
      } else {
        setDb(null);
      }
    });
  };

  const deleteData = (id, name) => {
    swal(`Estas seguro de eliminar el producto: "${name}"`, {
      dangerMode: true,
      buttons: true,
    }).then((result) => {
      if (result) {
        let endpoint = `${url}${id}`;
        let options = {
          headers: { "Content-type": "application/json" },
        };
        api.del(endpoint, options).then((res) => {
          if (!res.err) {
            let newData = Object.values(db).filter((el) => el.id !== id);
            setDb(newData);
          } else {
            return;
          }
        });
      }
    });
  };

  const data = {
    db,
    loader,
    createData,
    updateData,
    deleteData,
    dataToEdit,
    setDataToEdit,
    auth,
    setAuth,
  };

  return <CrudContext.Provider value={data}>{children}</CrudContext.Provider>;
};

export { CrudProvider };
export default CrudContext;
